import { EpicSettings, EpicSettingsFromJSON } from "./EpicSettings";
import { Tag, TagFromJSON } from "./Tag";
import { Project, ProjectFromJSON } from "./Project";

export interface Epic {
    id: number;
    subject: string;
    tags?: Array<Tag>;
    project?: Project;
    account?: string;
    bitmaker_settings?: EpicSettings;
    assignee?: string;
    assignee_id?: number;
}

export function EpicFromJSON(json: any): Epic {
    return {
        id: json["id"],
        subject: json["subject"],
        tags:
            json["tags"] === undefined || json["tags"] == null
                ? undefined
                : (json["tags"] as Array<any>).map(TagFromJSON),
        project:
            json["project"] === undefined || json["project"] == null
                ? undefined
                : ProjectFromJSON(json["project"]),
        account:
            json["account"] === undefined || json["account"] == null
                ? undefined
                : json["account"],
        bitmaker_settings:
            json["bitmaker_settings"] === undefined ||
                json["bitmaker_settings"] == null
                ? undefined
                : EpicSettingsFromJSON(json["bitmaker_settings"]),
        assignee:
            json["assignee"] === undefined || json["assignee"] == null
                ? undefined
                : json["assignee"],
        assignee_id:
            json["assignee_id"] === undefined || json["assignee_id"] == null
                ? undefined
                : json["assignee_id"],
    };
}

